import type { DetectedLink } from '../../integrations';

export function detectJIRALink(url: string): DetectedLink | null {
  const jiraMatch = url.match(
    /https?:\/\/([^/]+)\.atlassian\.net\/(?:browse|jira\/software\/projects\/[^/]+\/issues)\/([A-Z]+-\d+)/i
  );
  if (jiraMatch) {
    return {
      url,
      integrationType: 'jira',
      resourceType: 'issue',
      resourceId: jiraMatch[2],
      projectKey: jiraMatch[2].split('-')[0],
    };
  }
  return null;
}
